<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="titulo-modal mb-2">
            Descrição das categorias do dashboard
          </span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" class="mb-1">
              <p class="fontsize-descricao">Atendimentos abertos:</p>
            </v-col>
          </v-row>
          <div class="row-item card-abertos-novos pa-2 mb-2">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="ma-0 pa-0 d-flex align-start">
                <v-icon small class="abertos-novos pt-1"
                  >mdi-checkbox-blank-circle</v-icon
                >
                <p class="ml-2">
                  <strong>Novos:</strong> Todos os atendimentos que são
                  abertos para diferentes clientes no mesmo dia, são
                  considerados como novos atendimentos.
                </p>
              </v-col>
            </v-row>
          </div>
          <div class="row-item card-abertos-outros pa-2 mb-2">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="ma-0 pa-0 d-flex align-start">
                <v-icon small class="abertos-outros pt-1"
                  >mdi-checkbox-blank-circle</v-icon
                >
                <p class="ml-2">
                  <strong>Outros:</strong> Quantidade de atendimentos 
                  subsequentes (exceto o primeiro) abertos para o mesmo
                  cliente em um dia. Exemplo: Se um cliente abre 3
                  atendimentos no mesmo dia, será contado 1 em "Novos"
                  e 2 em "Outros".
                </p>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="12">
              <p class="fontsize-descricao mb-1">Atendimentos resolvidos:</p>
            </v-col>
          </v-row>

          <div class="row-item card-encerrados-primeiro-contato pa-2 mb-2">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="ma-0 pa-0 d-flex align-start">
                <v-icon small class="encerrados-primeiro-contato pt-1"
                  >mdi-checkbox-blank-circle</v-icon
                >
                <p class="ml-2">
                  <strong>Primeiro contato:</strong> Quantidade de atendimentos
                  resolvidos em primeiro contato pelo(s) analista(s)
                  selecionado(s). Isso significa que o atendente
                  fechou o atendimento no mesmo dia em que foi 
                  aberto para esse cliente.
                </p>
              </v-col>
            </v-row>
          </div>
          <div class="row-item card-encerrados-de-terceiros pa-2 mb-2">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="ma-0 pa-0 d-flex align-start">
                <v-icon small class="encerrados-de-terceiros pt-1"
                  >mdi-checkbox-blank-circle</v-icon
                >
                <p class="ml-2">
                  <strong>De terceiros:</strong> Quantidade de atendimentos 
                  iniciados por outro analista e 
                  finalizados pelo(s) analista(s) selecionado(s).
                </p>
              </v-col>
            </v-row>
          </div>
          <div class="row-item card-encerrados-outros pa-2 mb-2">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="ma-0 pa-0 d-flex align-start">
                <v-icon small class="encerrados-outros pt-1"
                  >mdi-checkbox-blank-circle</v-icon
                >
                <p class="ml-2">
                  <strong>Outros:</strong> Quantidade total de atendimentos 
                  finalizados, exceto aqueles resolvidos em primeiro contato
                  pelo(s) analista(s) selecionado(s).
                </p>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="btn-quaternary ml-0 mb-3"
            text
            @click="$emit('fecharModal')"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.fontsize-descricao {
  font-size: 1.1rem;
}

.icon-legenda {
  width: 15px;
  height: 15px;
  border-radius: 30px;
}

.abertos-novos {
  color: #0077c2;
}

.abertos-outros {
  color: #82b0db;
}

.encerrados-primeiro-contato {
  color: #009faf;
}

.encerrados-de-terceiros {
  color: #ffb74d;
}

.encerrados-outros {
  color: #8d8d8d;
}

.row-item {
  border-radius: 5px;
}

.card-abertos-novos {
  background-color: #0077c220;
}

.card-abertos-outros {
  background-color: #82b0db20;
}

.card-encerrados-primeiro-contato {
  background-color: #009faf20;
}

.card-encerrados-de-terceiros {
  background-color: #ffb74d20;
}

.card-encerrados-outros {
  background-color: #8d8d8d20;
}
</style>
